module.exports = __webpack_public_path__ + "images/emoji/joy_cat.6ff2fb835ef52c04825e.png";